import { styled } from 'styled-components'

const ButtonContainer = styled.div`
  padding: 10px 0px;
  position: relative;
  display: flex;
  align-items: center;
`

export default ButtonContainer
